import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import { ReactElement, type CSSProperties } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import TimeLine from '../TimeLine'
import { InfoboxComponent } from '../InfoboxComponent'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Header from 'components/Header'
import { HeaderInjection } from '@ta-interaktiv/react-header-injection'
import { MFContextProvider, url } from 'components/MFHelpers'

const HeaderAnimation = ({
  desktop,
  mobile,
  darkDesktop,
  darkMobile,
  colorMode,
  caption,
  videoStyles,
}: {
  desktop: string
  mobile: string
  darkDesktop: string
  darkMobile: string
  colorMode: 'light' | 'dark'
  caption?: string
  videoStyles: CSSProperties
}) => {
  const { width } = useWindowSize()
  const isMobile = width < 768
  const headerSource =
    colorMode === 'dark'
      ? isMobile
        ? darkMobile
        : darkDesktop
      : isMobile
        ? mobile
        : desktop
  const mp4Source = headerSource.replace(/\.png$/, '.mp4')
  const webmSource = headerSource.replace(/\.png$/, '.webm')

  return (
    <>
      <video
        key={headerSource}
        width='100%'
        height='auto'
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        style={videoStyles}
      >
        <source src={mp4Source} type='video/mp4' />
        <source src={webmSource} type='video/webm' />
      </video>
      {caption && (
        <div
          style={{
            textAlign: 'right',
            color: '#7d7d7d',
            margin: '-2rem 1rem 2rem 0',
            fontFamily: 'Libre Franklin, sans-serif',
          }}
        >
          {caption}
        </div>
      )}
    </>
  )
}

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const modules: { [key: string]: ReactElement } = {
    header: (
      <MFContextProvider
        locale={tenant.lang}
        colorMode={colorMode}
        // translations={{ de, fr }}
        tenantKey={tenant.key}
        trackEvent={trackEvent}
        properties={properties as { [key: string]: string }}
      >
        <HeaderInjection
          content={
            <HeaderAnimation
              desktop={url(
                tenant.lang === 'fr' ? 'header-fr.png' : 'header.png',
              )}
              mobile={url(
                tenant.lang === 'fr'
                  ? 'header-mobile-fr.png'
                  : 'header-mobile.png',
              )}
              darkDesktop={url(
                tenant.lang === 'fr' ? 'header-fr.png' : 'header.png',
              )}
              darkMobile={url(
                tenant.lang === 'fr'
                  ? 'header-mobile-fr.png'
                  : 'header-mobile.png',
              )}
              colorMode={colorMode}
              caption='Illustration: Felix Schaad'
              videoStyles={{
                maxWidth: '100%',
                marginBottom: '0px',
                mixBlendMode: colorMode === 'dark' ? 'normal' : 'darken',
              }}
            />
          }
        />
      </MFContextProvider>
    ),
    header_old: (
      <Header
        titleText={properties?.titleText}
        leadText={properties?.leadText}
        caption={'Illustration: Felix Schaad'}
        authors={
          properties && properties?.authors
            ? JSON.parse('[' + properties?.authors + ']')
            : undefined
        }
        publishDate={properties?.publishDate}
        tenant={tenant}
      />
    ),
    timeline: (
      <div>
        <TimeLine
          titleText={properties?.titleText}
          colorMode={colorMode}
          tenant={tenant}
        />
      </div>
    ),
    infobox: (
      <div>
        <InfoboxComponent
          defaultModeOpen={properties?.defaultModeOpen}
          colorMode={colorMode}
          title={properties?.title}
          trackEvent={trackEvent}
          dwSourceUrl={
            typeof properties?.dwSourceUrl === 'string'
              ? JSON.parse(properties?.dwSourceUrl)
              : properties?.dwSourceUrl
          }
          iFrameStyleHeight={properties?.iFrameStyleHeight}
          // paragraphs={
          //   typeof properties?.paragraphs === 'string'
          //     ? JSON.parse(properties?.paragraphs)
          //     : properties?.paragraphs
          // }
        />
      </div>
    ),
  }

  return (
    <AppContainer $colorMode={colorMode}>
      {properties && <>{modules[properties.module]}</>}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  ${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
